// extracted by mini-css-extract-plugin
module.exports = {"right":"funding-request-list_right__U5EHJ","item":"funding-request-list_item__5AmZJ","label":"funding-request-list_label__krZup"};